{
    "v": "5.8.1",
    "fr": 30,
    "ip": 0,
    "op": 60,
    "w": 500,
    "h": 500,
    "nm": "40 Line Bars",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 3,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Line Bars",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [118.198, 178.814],
                                                    [118.198, -33.38],
                                                    [178.825, -33.38],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 14.813,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [118.198, 178.814],
                                                    [119.023, -131.38],
                                                    [179.65, -131.38],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 23.931,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [118.198, 178.814],
                                                    [118.719, 28.62],
                                                    [179.346, 28.62],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 34.187,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [118.198, 178.814],
                                                    [119.438, -149.38],
                                                    [180.065, -149.38],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 49,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [118.198, 178.814],
                                                    [118.198, -33.38],
                                                    [178.825, -33.38],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-124.311, 178.814],
                                                    [-124.311, 87.874],
                                                    [-63.684, 87.874],
                                                    [-63.684, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 14.813,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-124.311, 178.814],
                                                    [-124.621, 135.874],
                                                    [-63.994, 135.874],
                                                    [-63.684, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 23.931,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-124.311, 178.814],
                                                    [-125.242, -22.126],
                                                    [-64.615, -22.126],
                                                    [-63.684, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 34.187,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-124.311, 178.814],
                                                    [-124.485, -84.126],
                                                    [-63.858, -84.126],
                                                    [-63.684, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 49,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-124.311, 178.814],
                                                    [-124.311, 87.874],
                                                    [-63.684, 87.874],
                                                    [-63.684, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-178.875, -178.886],
                                                    [-178.875, 178.814],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 49,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-178.875, -178.886],
                                                    [-178.875, 178.814],
                                                    [178.825, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-3.056, 178.814],
                                                    [-3.056, -154.635],
                                                    [57.571, -154.635],
                                                    [57.571, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 14.813,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-3.056, 178.814],
                                                    [-3.486, 41.365],
                                                    [57.141, 41.365],
                                                    [57.571, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 23.931,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-3.056, 178.814],
                                                    [-4.061, -106.635],
                                                    [56.566, -106.635],
                                                    [57.571, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.63, "y": 1 },
                                        "o": { "x": 0.37, "y": 0 },
                                        "t": 34.187,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-3.056, 178.814],
                                                    [-4.75, 23.365],
                                                    [55.877, 23.365],
                                                    [57.571, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    },
                                    {
                                        "t": 49,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-3.056, 178.814],
                                                    [-3.056, -154.635],
                                                    [57.571, -154.635],
                                                    [57.571, 178.814]
                                                ],
                                                "c": false
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0.047, 0.047, 0.047, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
